import React from "react";

import { Form, Formik } from "formik";
import { Grid } from "@material-ui/core";

import { Button, SecondaryButton } from "components/Form";
import { SelectField } from "components/Form/FormikControls";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  ZoomyDialog,
} from "components/MaterialDialog";
import { SplitAllocationForm } from "components/TransactionSplits/SplitAllocationForm";
import { SplitOrigin, SplitType, SplitTypeOptions } from "constants/splits";
import { validateVendorSplits } from "lib/splits";

interface PendingVendorSplitAllocation {
  businessId: string;
  amount: string | number;
  shouldChargeGSTOverride: boolean | null;
}

export interface PendingVendorSplit {
  type: SplitType;
  splits: PendingVendorSplitAllocation[];
}

interface Props {
  primaryBusinessId: string;
  quantity: number | null;
  initialSplit?: PendingVendorSplit | null;
  onSave: (split: PendingVendorSplit) => void;
  onClose: () => void;
}

export const AddVendorSplitDialog = ({
  primaryBusinessId,
  quantity,
  initialSplit,
  onSave,
  onClose,
}: Props) => {
  const initialValues: PendingVendorSplit = initialSplit ?? {
    type: SplitType.PERCENTAGE,
    splits: [
      {
        businessId: primaryBusinessId,
        amount: 1,
        shouldChargeGSTOverride: null,
      },
    ],
  };

  const validate = (values: PendingVendorSplit) =>
    validateVendorSplits(values.splits, values.type, quantity);

  return (
    <ZoomyDialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle onClose={onClose}>
        {initialSplit ? "Edit" : "Add"} Vendor Split
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        validate={validate}
        onSubmit={values => {
          onSave(values);
          onClose();
        }}
      >
        <Form>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SelectField
                  name="type"
                  label="Type"
                  tooltip="Only Sale Lots can be split by head count."
                  options={SplitTypeOptions}
                  menuPortalTarget={document.body}
                />
              </Grid>
              <SplitAllocationForm splitType={SplitOrigin.VENDOR} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <SecondaryButton type="button" onClick={onClose}>
              Cancel
            </SecondaryButton>
            <Button type="submit">Save</Button>
          </DialogActions>
        </Form>
      </Formik>
    </ZoomyDialog>
  );
};
